<template>
  <b-modal size="md" v-model="show" centered :title="'Ausführend: '+todo.name"
  >
    <b-row>
      <b-col>
        <span>Zieldatum</span>
        <datetime
            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
            v-model="todo.dueDate"
            input-class="form-control"
            input-style="color: black;"
            input-id="date"
            :phrases="datetimeConfig.phrases"
            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
            :min-datetime="datetimeConfig.minTime"></datetime>
        <b-form-group
            class="mt-2"
            label="Ausführungsanweisung:"
        >
          <b-form-textarea
              class="text-black"
              rows="6"
              max-rows="40"
              wrap="hard"
              v-model="todo.memo"
              style="min-height: 150px; color: black"

          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinue" variant="success" @click="onSelected">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import {DateTime as LuxonDateTime} from "luxon";

export default {
  name: "ChangeTodoDialog",
  data() {
    return {
      show: false,
      todo: {
        name: '',
        memo: '',
        dueDate: null,
      },
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
    }
  },
  computed: {
    canContinue() {
      return this.todo.dueDate !== null && this.todo.dueDate !== "";
    }
  },
  methods: {
    onSelected() {
      this.show = false;
      this.$emit("change-todo", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog(todo) {
      if (!todo) {
        return;
      }
      this.todo = JSON.parse(JSON.stringify(todo));
      this.show = true;
    },
    getReturnData: function () {
      return this.todo;
    },
  }
}
</script>

<style>
.display_none {
  display: none;
}

.form-control:disabled {
  color: black;
}

.text-black {
  color: black;
}
</style>
